import { Breadcrumb, Modal } from 'antd';
import { FunctionComponent, useEffect, useState } from 'react';
import { getNews } from '../../../api/NetworkingWidget';
import { getResource } from '../../../helpers/ResourcesHelper';
import Button from '../../inputs/Button';
import './../../../../src/styles/news-widgets.scss';
import NewsItem from './NewsItem';

interface NewsProps {
  width: string,
  height: string,
}

const News: FunctionComponent<NewsProps> = (props: any) => {

  const [objNews, setObjNews] = useState({} as any);
  const [showNewsModal, setshowNewsModal] = useState(false);
  const [listNews, setListNews] = useState([] as any);

  useEffect(() => {
    const customerID = JSON.parse(localStorage.getItem('UserSession')!).CustomerID;
    getNews().then(
      (response) => {
        console.log('news')
        console.log(response)
        setListNews(response.News)
      }
    );
  }, [])

  const clickedItemNews = (itemNews: any) => {
    if (itemNews !== undefined) {
      setObjNews(itemNews);
      setshowNewsModal(true);
    }
  }

  const closeShowNewsModal = () => {
    setObjNews({});
    setshowNewsModal(false);
  }

  return (
    <div
      style={{
        width: props.width,
        height: props.height,
        overflow: 'auto',
        flexDirection: 'column',
        padding: '10px 5px',
        display: 'flex',
        alignItems: 'stretch',
        margin: '0 auto',
      }}
    >
      <div className="breadcrumb-container">
        <Breadcrumb separator="">
          <Breadcrumb.Item >{getResource('Tittle.News')}</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <ul
        style={{
          listStyleType: 'none',
          margin: 0,
          padding: 2
        }}
      >
        {listNews != null &&
          listNews.map(
            (item: any, index: number) =>
              <NewsItem
                news={item}
                key={index}
                onClickNewsItem={clickedItemNews}
              />
          )
        }
      </ul>
      <Modal
        title={
            <Breadcrumb separator="">
              <Breadcrumb.Item >{getResource('Tittle.News')}</Breadcrumb.Item>
          </Breadcrumb>
        }
        className='modal-news-container'
        centered
        visible={showNewsModal}
        footer={null}
        onCancel={closeShowNewsModal}
        maskClosable={false}
        width={'30%'}
        zIndex={1020}
        closable={false}
      >
        <div className="row">
          <div className="bold-text news-label">Subject:</div>
          <div className="col-xs-4">{objNews.Subject}</div>
        </div>
        <div className="row">
          <div className="bold-text news-label">Date Posted:</div>
          <div className="col-xs-4">{objNews.DatePosted}</div>
        </div>
        <div className="row">
          <div className="bold-text news-label">Message:</div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xs-12" style={{ border: '1px solid #E7E7E7', margin: '1px' }}>
            <div className="news-message-contenedor" dangerouslySetInnerHTML={{ __html: objNews.Message }} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <Button id="confirmation-OK" type="primary" onClick={closeShowNewsModal}>
              {getResource('Button.Ok')}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
export default News;